import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

export const onAgentKnowledgeCardCarouselShown = (
	props: commonAttributesType & { agentCount: number },
): AnalyticsEventPayload => {
	const { source, agentCount } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAgentKnowledgeCardCarousel',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			agentCount,
		},
	};
};
